var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.275 6.275C0.0916663 6.09167 0 5.85833 0 5.575C0 5.29167 0.0916663 5.05833 0.275 4.875L4.875 0.275C4.975 0.175 5.08333 0.104333 5.2 0.0629997C5.31667 0.0216664 5.44167 0.000666667 5.575 0C5.70833 0 5.83767 0.0249998 5.963 0.0749998C6.08833 0.125 6.19233 0.191666 6.275 0.275L10.875 4.875C11.0583 5.05833 11.15 5.29167 11.15 5.575C11.15 5.85833 11.0583 6.09167 10.875 6.275C10.6917 6.45833 10.4583 6.55 10.175 6.55C9.89167 6.55 9.65833 6.45833 9.475 6.275L5.575 2.375L1.675 6.275C1.49167 6.45833 1.25833 6.55 0.975 6.55C0.691667 6.55 0.458333 6.45833 0.275 6.275Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.924149cd3b75428f64ab779e917a93bd.svg";
export { ForwardRef as ReactComponent };